import React from "react";
import SocialCard from "./SocialCard";
import {
  AiFillGithub,
  AiFillInstagram,
  AiFillLinkedin,
  AiOutlineTwitter,
} from "react-icons/ai";
import HorizontalLine from "../HorizontalLine";
import { Button } from "@mui/material";
import TextareaAutosize from "@mui/material/TextareaAutosize";
import { motion, useAnimation } from "framer-motion";
import { useEffect } from "react";
import { useInView } from "react-intersection-observer";

const Contect = ({ contactRef }) => {
  const contactAnimation = useAnimation();
  const [ref, inView] = useInView({ threesold: 0.1 });
  useEffect(() => {
    if (inView) {
      contactAnimation.start({
        x: 0,
        opacity: 1,
        transition: {
          delay: 0.2,
          ease: "easeInOut",
          duration: 0.5,
        },
      });
    } else {
      contactAnimation.start({
        x: 300,
        opacity: 0,
      });
    }
  }, [inView]);

  return (
    <div ref={contactRef} className="pt-40  px-2 lg:px-20 ">
      <HorizontalLine section={"Contact"} />

      <div className="mt-16 lg:mt-32  rounded-md shadow-2xl shadow-blue-400 bg-black bg-opacity-40">
        <div className=" -translate-y-8 lg:-translate-y-24 flex justify-center space-x-6 items-center">
          {/* <hr className="w-[20%] h-0 border-t-[1px] border-gray-700 	box-shadow: 0 0 5px 5px olive" /> */}
          <a href="https://github.com/developer207" target={"-blanck"}>
            <SocialCard
              className=""
              gitIcon={<AiFillGithub className="text-5xl text-blue-800" />}
              title="Github"
              username={"Ashokzarmariya"}
            />
          </a>

          {/* <hr className="w-[10%] h-0 border-t-[1px] border-gray-700 " /> */}
          <a
            href="https://www.linkedin.com/in/ashok-zarmariya-473aa722a/"
            target={"-blanck"}
          >
            <SocialCard
              gitIcon={<AiFillLinkedin className="text-5xl text-blue-800" />}
              title="Linkedin"
              username="ashokzarmariya"
            />
          </a>

          {/* <hr className="w-[10%] h-0 border-t-[1px] border-gray-700 " /> */}
          <a href="https://twitter.com/Ashokzarmariya" target={"-blanck"}>
            <SocialCard
              className=""
              gitIcon={<AiOutlineTwitter className="text-5xl text-blue-800" />}
              title="Twitter"
              username="ashokzarmariya"
            />
          </a>

          <a
            href="https://www.instagram.com/ashok.zarmariya/"
            target={"-blanck"}
          >
            <SocialCard
              gitIcon={<AiFillInstagram className=" text-5xl text-blue-800" />}
              title="Instagram"
              username="ashok.zarmariya"
            />
          </a>
        </div>
        <div className="flex flex-col lg:flex-row justify-between items-end pb-10">
          <div className="hidden lg:block w-1/2 px-2 lg:pl-32 relative">
            <img
              className="rounded-md absolute -bottom-2 left-28"
              src="at-1020063_960_720-removebg-preview.png"
              alt=""
            />
            
           
            
          </div>

          {/* contect form */}

          <motion.div
            ref={ref}
            animate={contactAnimation}
            className="w-[97%] lg:w-1/2 px-6 py-10 flex flex-col items-center"
          >
            <div className="flex flex-col justify-center items-center shadow-md shadow-blue-600 py-5 lg:p-5 space-y-10 w-full lg:w-[60%] bg-black bg-opacity-50">
              <p className="font-bold text-blue-600">Contact Me</p>
              <input
                className="placeholder:text-white bg-black bg-opacity-50 outline-none text-white border-b-2 border-b-gray-500 w-[90%] p-5 rounded-md"
                type="text"
                placeholder="Enter Your Name"
              />
              <input
                className="placeholder:text-white bg-black bg-opacity-50 outline-none text-white border-b-2 border-b-gray-500 w-[90%] p-5 rounded-md"
                type="text"
                placeholder="Enter Your Email"
              />
              <TextareaAutosize
                aria-label="minimum height"
                minRows={2}
                placeholder="Write your Message"
                style={{
                  width: "90%",
                  resize: "none",
                  outline: "none",
                  background: "black",
                  color: "white",
                }}
                className="placeholder:text-white bg-black bg-opacity-50 outline-none text-white border-b-2 border-b-gray-500 w-[90%] p-5 rounded-md"
              />

              <Button className="w-[90%]" size="large" variant="outlined">
                Send
              </Button>
            </div>
          </motion.div>
        </div>
      </div>
    </div>
  );
};

export default Contect;
